"use strict";

exports.__esModule = true;
exports.DeviceDetailsReportDataProvider = DeviceDetailsReportDataProvider;
var _react = _interopRequireDefault(require("react"));
var _URLFilter = require("../../Core/URLFilter");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _PlantStateActivities = require("../../PlantStateActivities");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _Calendar = require("../../Calendar");
var _ClassificationContext = require("../../Operator/ClassificationContext");
var _CycleSplitterDialog = require("../../Operator/CycleSplitter/CycleSplitterDialog");
var _Device = require("../../Device");
var _DeviceDetailsURLFilter = require("../../DeviceDetails/DeviceDetailsURLFilter");
var _Operator = require("../../Operator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DeviceDetailsReportDataProvider(props) {
  var _props$defaultToFirst = props.defaultToFirstDevice,
    defaultToFirstDevice = _props$defaultToFirst === void 0 ? true : _props$defaultToFirst,
    config = props.config,
    children = props.children,
    timeRangeKind = props.timeRangeKind;
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var classification = _react["default"].useContext(_PlantStateActivities.PlantStateActivitiesContext);
  var plantStateActivitiesDevice = _react["default"].useContext(_PlantStateActivities.PlantStateActivitiesDevicesContext);
  return /*#__PURE__*/_react["default"].createElement(_Calendar.CalendarController, null, function (calendarProps) {
    return /*#__PURE__*/_react["default"].createElement(_Calendar.CalendarContext.Provider, {
      value: calendarProps
    }, /*#__PURE__*/_react["default"].createElement(_DeviceDetailsURLFilter.DeviceDetailsURLFilter, {
      timeRangeKind: timeRangeKind
    }, function (urlFilter) {
      var deviceUuid = urlFilter.filters.device;
      var deviceList = Array.isArray(devices) ? devices : [];
      var device = deviceUuid ? deviceList.find(function (item) {
        return item.uuid === deviceUuid;
      }) : undefined;
      if (device === undefined && defaultToFirstDevice) {
        device = deviceList[0];
      }
      var plantStateActivities = device ? (0, _Operator.filterPlantStateActivities)(classification, config, device.allowProducing, plantStateActivitiesDevice, device.uuid) : undefined;
      return /*#__PURE__*/_react["default"].createElement(_URLFilter.URLFilterContext.Provider, {
        value: urlFilter
      }, /*#__PURE__*/_react["default"].createElement(_Device.DeviceContext.Provider, {
        value: device
      }, /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodController, null, function (reportingPeriod) {
        return /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodContext.Provider, {
          value: reportingPeriod
        }, device ? /*#__PURE__*/_react["default"].createElement(_ClassificationContext.ClassificationContext.Provider, {
          plantStateActivities: plantStateActivities,
          device: device,
          interval: reportingPeriod.interval
        }, /*#__PURE__*/_react["default"].createElement(_ClassificationContext.ClassificationContext.Consumer, null, function (classification) {
          var selectedCycles = classification.getSelectedCycles();
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, selectedCycles.length > 0 && /*#__PURE__*/_react["default"].createElement(_CycleSplitterDialog.CycleSplitterDialog, {
            isOpen: classification.isSplitterDialogOpen,
            onClose: classification.toggleSplitterDialog,
            onSplit: classification.splitCycles,
            classification: selectedCycles[0],
            cycles: classification.cycles,
            plantStateActivities: plantStateActivities
          }));
        })) : children);
      })));
    }));
  });
}